"use client"

import { useState } from "react"
import {
  CalculatorCard,
  FormulaNote,
  NumberField,
  ResultStat,
  formatMultiple,
  parseNum,
} from "./calculator-ui"

/**
 * Break-even ROAS = 1 ÷ gross-margin-fraction.
 * The margin input is a percentage; we divide by 100 before the maths.
 * Default example: 40% margin → 1 / 0.40 = 2.5× break-even ROAS.
 * Assumption: gross margin is the contribution margin BEFORE ad spend.
 */
export function BreakEvenRoasWidget() {
  const [marginPct, setMarginPct] = useState("40")

  const pct = parseNum(marginPct)
  const fraction = pct !== null ? pct / 100 : null
  const breakEven =
    fraction !== null && fraction > 0 ? 1 / fraction : NaN

  return (
    <CalculatorCard title="Break-Even ROAS Calculator">
      <NumberField
        id="be-margin"
        label="Gross profit margin"
        value={marginPct}
        onChange={setMarginPct}
        suffix="%"
        hint="Contribution margin before ad spend — revenue minus COGS, shipping, fees."
      />

      <div className="mt-6">
        <ResultStat
          label="Break-even ROAS"
          value={formatMultiple(breakEven)}
          tone={Number.isFinite(breakEven) ? "warn" : "neutral"}
          caption={
            Number.isFinite(breakEven)
              ? `You need at least ${formatMultiple(breakEven)} ROAS to avoid losing money. Anything above is profit.`
              : "Enter a gross margin above 0%."
          }
        />
      </div>

      <FormulaNote>Break-even ROAS = 1 ÷ Gross margin (as a fraction). Example: 40% margin → 1 / 0.40 = 2.5×.</FormulaNote>
    </CalculatorCard>
  )
}
